import React, { useContext } from "react";
import Box from "@material-ui/core/Box";
import { Dialog, DialogTitle } from "@mui/material";
import { Button, Grid, Stack } from "@material-ui/core";

import { Save } from "@material-ui/icons";

import { Formik } from "formik";

import BasicInputField from "../form/BasicInputField";
import { BrandContext } from "../../../contexts/BrandContext";
import { getValidationFromFields, initialValues } from "../form/FormUtilities";
import { getComponentsFromUtcDate, hoursMinFromTime } from "../../../contexts/BookingUtilities";
import axios from "../../../utils/axios";
import { cWarn } from "../CustomLogger";


export default function TimeEdit(props){


    const {
        showDialogue,
        setShowDialogue,
        wayPointId=0,
        pointTime,
        updateCall
    } = props;

    const brandContext = useContext(BrandContext);
    const {textContent} = brandContext;
    
    const {
        taxiBookingEditPickupTime:dialogueTitle='',
        widget_saveButton:saveButton=''

    } = textContent;

    
    const{
        hours,
        mins

    } = getComponentsFromUtcDate(pointTime);


    const defTime = new Date();
    defTime.setHours(hours);
    defTime.setMinutes(mins)


    const formFields = {
        'waypointTime': {
            'label': 'travelTimeFormLabel',
            'type':'timePicker',
            'default':defTime
        },
    }


    return (
        <Dialog open={showDialogue} onClose={()=>{setShowDialogue(false)}}>
            <DialogTitle>{dialogueTitle}</DialogTitle>
            <Formik
                initialValues={initialValues(formFields)}
                validationSchema={getValidationFromFields(formFields)}
                onSubmit={(values)=>{
                    const {waypointTime} = values;
                    const hoursMin = hoursMinFromTime(waypointTime);
                    const apiPath = `${process.env.REACT_APP_API_URL}/taxibooking/waypoint/time/${wayPointId}`;
                    axios.post(apiPath,hoursMin,{
                        timeout: 300000,
                        withCredentials:true
                    }).then(() => {
                        if(updateCall){
                            updateCall(waypointTime);
                        }
                    }).catch(err => {
                       // console.log('caught the error');
                       cWarn(err);
                    });
                }}
            >
                {props => (
                    <Box p={3}>
                        <Stack spacing={2}  alignItems="center">
                            <form onSubmit={props.handleSubmit}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} md={12}>
                                        <BasicInputField 
                                            sx={{width:'100%'}}  
                                            formik={props} 
                                            formFields={formFields} 
                                            fieldName="waypointTime"
                                        />
                                    </Grid>
                                </Grid>
                            </form>
                            <Button
                                className="bookingButton"
                                variant="outlined"
                                onClick={()=>{props.handleSubmit()}}
                                startIcon={<Save/>}
                            >
                                {saveButton}
                            </Button>
                        </Stack>
                    </Box>
                )}
            </Formik>
        </Dialog>
    );


}

